import React, { useState, useEffect, useContext } from 'react';
import styles from './styles/CookiePopup.module.css';
import Cookies from 'js-cookie';
import { useNavigate } from "react-router-dom";
import { LanguageContext } from '../../Context/changeLanguageProvider';
import parse from "html-react-parser";
export function CookiePopup() {
	const [showPopup, setShowPopup] = useState(false);
    const [showSettings, setShowSettings] = useState(false);
    const navigate = useNavigate();
    const websiteCurrentLang = useContext(LanguageContext).language;
    const [content, setContent] = useState(
      websiteCurrentLang.content.CookiePopup.cookiePopup
    );
    const [dublicatedcontent, setDublicatedContent] = useState(
      websiteCurrentLang.content.DublicatedText
    );
    useEffect(() => {
      setContent(websiteCurrentLang.content.CookiePopup.cookiePopup);
      setDublicatedContent(websiteCurrentLang.content.DublicatedText);
    }, [websiteCurrentLang]);
	useEffect(() => {
		const cookieValue = Cookies.get('ostreon_cookie_popup');

		if (cookieValue && cookieValue === 'true') {
			setShowPopup(false);
		} else {
            setShowPopup(true);
        }
	}, []);

    const closePopup = () => {
        // Set the cookie to indicate that the popup has been shown
        Cookies.set('ostreon_cookie_popup', 'true', { expires: 365 }); // Expires after 365 days
        // Close the popup
        setShowPopup(false);
    };

    const showSettingsPopup = () => {
        setShowSettings(!showSettings);
    }
    const saveAllCookies = () => {
        closePopup();
    }
    const saveEssentialCookies = () => {
        closePopup();
    }

	return (
        <>
          {showPopup && (
            <div className={styles.cookie}>
              <div className={styles.overlay}></div>
              {!showSettings && (
                <div className={styles.cookie_popup}>
                  <div className={styles.cookie_popup_text}>
                    <div className={styles.title}>
                      {dublicatedcontent.dublicatedText69}
                    </div>
                    <div className={styles.text}>
                      {parse(content.cookiePopupText1)}
                      <a
                        className={styles.link}
                        onClick={() => navigate("/cookies-policy")}
                      >
                        {dublicatedcontent.dublicatedText68}
                      </a>
                    </div>
                  </div>
                  <div className={styles.cookie_popup_actions}>
                    <button
                      className={`${styles.whitebutton} ${styles.button}`}
                      onClick={showSettingsPopup}
                    >
                      {dublicatedcontent.dublicatedText69}
                    </button>
    
                    <button
                      className={`${styles.bluebutton} ${styles.button}`}
                      onClick={saveAllCookies}
                    >
                      {content.cookiePopupText4}
                    </button>
                  </div>
                </div>
              )}
              {showSettings && (
                <div className={styles.cookie_settings}>
                  <div className={styles.settings_title}>
                    {content.cookiePopupText5}
                  </div>
                  <div className={styles.settings_text}>
                    <p>{content.cookiePopupText6}</p>
                    <p>{content.cookiePopupText7}</p>
                    <p>
                      <strong>{content.cookiePopupText8}</strong>
                      <br />
                      {content.cookiePopupText9}
                    </p>
                    <strong>{content.cookiePopupText10}</strong>
                    <ol className={styles.list}>
                      <li>
                        <u>{content.cookiePopupText11}</u>{" "}
                        {content.cookiePopupText12}
                      </li>
                      <li>
                        <u>{content.cookiePopupText13}</u>{" "}
                        {content.cookiePopupText14}
                      </li>
                      <li>
                        <u>{content.cookiePopupText15}</u>{" "}
                        {content.cookiePopupText16}
                      </li>
                    </ol>
                    <p>
                      {content.cookiePopupText17}
                      <a
                        onClick={() =>
                          navigate("/privacy-policy", { replace: true })
                        }
                        className={styles.link}
                      >
                        {dublicatedcontent.dublicatedText39}
                      </a>
                      &
                      <a
                        onClick={() =>
                          navigate("/privacy-policy", { replace: true })
                        }
                        className={styles.link}
                      >
                        {content.cookiePopupText19}
                      </a>
                      {content.cookiePopupText20}
                    </p>
                    <p>{content.cookiePopupText21}</p>
                    <p>
                      {content.cookiePopupText22}{" "}
                      <a
                        onClick={() => navigate("/contact-us")}
                        className={styles.link}
                      >
                        {dublicatedcontent.dublicatedText35}
                      </a>
                      .
                    </p>
                  </div>
                  <div className={styles.settings_actions}>
                    <button
                      className={`${styles.whitebutton} ${styles.button}`}
                      onClick={saveEssentialCookies}
                    >
                      {content.cookiePopupText24}
                    </button>
    
                    <button
                      className={`${styles.bluebutton} ${styles.button}`}
                      onClick={saveAllCookies}
                    >
                      {content.cookiePopupText25}
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </>
      );
}

export default CookiePopup;
